var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 562,
    height: 562,
    viewBox: "0 0 562 562",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.81 -1.90735e-06L133.81 26.7619L160.571 26.7619L160.571 4.32251e-07L133.81 -1.90735e-06Z",
    fill: "#EA6C58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.81 26.762L133.81 53.5239L160.571 53.5239L160.571 26.762L133.81 26.762Z",
    fill: "#EA6C58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.81 53.5239L133.81 80.2858L160.571 80.2858L160.571 53.5239L133.81 53.5239Z",
    fill: "#EA6C58"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.81 80.2858L133.81 107.048L160.571 107.048L160.571 80.2858L133.81 80.2858Z",
    fill: "#EA6C58"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.81 107.048L133.81 133.81L160.571 133.81L160.571 107.048L133.81 107.048Z",
    fill: "#EA6C58"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.81 133.81L133.81 160.571L160.571 160.571L160.571 133.81L133.81 133.81Z",
    fill: "#EA6C58"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M133.81 160.571L133.81 187.333L160.571 187.333L160.571 160.571L133.81 160.571Z",
    fill: "#EA6C58"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M133.81 187.333L133.81 214.095L160.571 214.095L160.571 187.333L133.81 187.333Z",
    fill: "#EA6C58"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133.81 214.095L133.81 240.857L160.571 240.857L160.571 214.095L133.81 214.095Z",
    fill: "#EA6C58"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M214.095 26.762L214.095 53.5239L240.857 53.5239L240.857 26.762L214.095 26.762Z",
    fill: "#EA6C58"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M214.095 80.2858L214.095 107.048L240.857 107.048L240.857 80.2858L214.095 80.2858Z",
    fill: "#EA6C58"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M214.095 107.048L214.095 133.81L240.857 133.81L240.857 107.048L214.095 107.048Z",
    fill: "#EA6C58"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M214.095 133.81L214.095 160.571L240.857 160.571L240.857 133.81L214.095 133.81Z",
    fill: "#EA6C58"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M214.095 160.571L214.095 187.333L240.857 187.333L240.857 160.571L214.095 160.571Z",
    fill: "#EA6C58"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M214.095 187.333L214.095 214.095L240.857 214.095L240.857 187.333L214.095 187.333Z",
    fill: "#EA6C58"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M214.095 214.095L214.095 240.857L240.857 240.857L240.857 214.095L214.095 214.095Z",
    fill: "#EA6C58"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M214.095 240.857L214.095 267.619L240.857 267.619L240.857 240.857L214.095 240.857Z",
    fill: "#EA6C58"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M214.095 267.619L214.095 294.381L240.857 294.381L240.857 267.619L214.095 267.619Z",
    fill: "#EA6C58"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M267.619 26.762L267.619 53.5239L294.381 53.5239L294.381 26.762L267.619 26.762Z",
    fill: "#EA6C58"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M267.619 53.5239L267.619 80.2858L294.381 80.2858L294.381 53.5239L267.619 53.5239Z",
    fill: "#EA6C58"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M267.619 80.2858L267.619 107.048L294.381 107.048L294.381 80.2858L267.619 80.2858Z",
    fill: "#EA6C58"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M267.619 107.048L267.619 133.81L294.381 133.81L294.381 107.048L267.619 107.048Z",
    fill: "#EA6C58"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M267.619 133.81L267.619 160.571L294.381 160.571L294.381 133.81L267.619 133.81Z",
    fill: "#EA6C58"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M267.619 160.571L267.619 187.333L294.381 187.333L294.381 160.571L267.619 160.571Z",
    fill: "#EA6C58"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M267.619 187.333L267.619 214.095L294.381 214.095L294.381 187.333L267.619 187.333Z",
    fill: "#EA6C58"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M267.619 240.857L267.619 267.619L294.381 267.619L294.381 240.857L267.619 240.857Z",
    fill: "#EA6C58"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M267.619 267.619L267.619 294.381L294.381 294.381L294.381 267.619L267.619 267.619Z",
    fill: "#EA6C58"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M267.619 294.381L267.619 321.143L294.381 321.143L294.381 294.381L267.619 294.381Z",
    fill: "#EA6C58"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M267.619 321.143L267.619 347.905L294.381 347.905L294.381 321.143L267.619 321.143Z",
    fill: "#EA6C58"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M267.619 347.905L267.619 374.667L294.381 374.667L294.381 347.905L267.619 347.905Z",
    fill: "#EA6C58"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M267.619 374.667L267.619 401.429L294.381 401.429L294.381 374.667L267.619 374.667Z",
    fill: "#EA6C58"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M267.619 401.429L267.619 428.19L294.381 428.19L294.381 401.429L267.619 401.429Z",
    fill: "#EA6C58"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M267.619 428.191L267.619 454.952L294.381 454.952L294.381 428.191L267.619 428.191Z",
    fill: "#EA6C58"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M267.619 454.952L267.619 481.714L294.381 481.714L294.381 454.952L267.619 454.952Z",
    fill: "#EA6C58"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2857 26.762L80.2857 53.5239L107.048 53.5239L107.048 26.762L80.2857 26.762Z",
    fill: "#EA6C58"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2857 53.5239L80.2857 80.2858L107.048 80.2858L107.048 53.5239L80.2857 53.5239Z",
    fill: "#EA6C58"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2857 80.2858L80.2857 107.048L107.048 107.048L107.048 80.2858L80.2857 80.2858Z",
    fill: "#EA6C58"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2857 107.048L80.2857 133.81L107.048 133.81L107.048 107.048L80.2857 107.048Z",
    fill: "#EA6C58"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2857 133.81L80.2857 160.571L107.048 160.571L107.048 133.81L80.2857 133.81Z",
    fill: "#EA6C58"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2857 160.571L80.2857 187.333L107.048 187.333L107.048 160.571L80.2857 160.571Z",
    fill: "#EA6C58"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2857 187.333L80.2857 214.095L107.048 214.095L107.048 187.333L80.2857 187.333Z",
    fill: "#EA6C58"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7618 133.81L26.7618 160.571L53.5237 160.571L53.5237 133.81L26.7618 133.81Z",
    fill: "#EA6C58"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7618 160.571L26.7618 187.333L53.5237 187.333L53.5237 160.571L26.7618 160.571Z",
    fill: "#EA6C58"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7618 187.333L26.7618 214.095L53.5237 214.095L53.5237 187.333L26.7618 187.333Z",
    fill: "#EA6C58"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7618 80.2858L26.7618 107.048L53.5237 107.048L53.5237 80.2858L26.7618 80.2858Z",
    fill: "#EA6C58"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M160.571 -1.90735e-06L160.571 26.7619L187.333 26.7619L187.333 4.32251e-07L160.571 -1.90735e-06Z",
    fill: "#EA6C58"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M160.571 26.762L160.571 53.5239L187.333 53.5239L187.333 26.762L160.571 26.762Z",
    fill: "#EA6C58"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M160.571 53.5239L160.571 80.2858L187.333 80.2858L187.333 53.5239L160.571 53.5239Z",
    fill: "#EA6C58"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M160.571 107.048L160.571 133.81L187.333 133.81L187.333 107.048L160.571 107.048Z",
    fill: "#EA6C58"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M160.571 133.81L160.571 160.571L187.333 160.571L187.333 133.81L160.571 133.81Z",
    fill: "#EA6C58"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M160.571 160.571L160.571 187.333L187.333 187.333L187.333 160.571L160.571 160.571Z",
    fill: "#EA6C58"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M160.571 187.333L160.571 214.095L187.333 214.095L187.333 187.333L160.571 187.333Z",
    fill: "#EA6C58"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M160.571 214.095L160.571 240.857L187.333 240.857L187.333 214.095L160.571 214.095Z",
    fill: "#EA6C58"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M240.857 26.762L240.857 53.5239L267.619 53.5239L267.619 26.762L240.857 26.762Z",
    fill: "#EA6C58"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M240.857 53.5239L240.857 80.2858L267.619 80.2858L267.619 53.5239L240.857 53.5239Z",
    fill: "#EA6C58"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M240.857 80.2858L240.857 107.048L267.619 107.048L267.619 80.2858L240.857 80.2858Z",
    fill: "#EA6C58"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M240.857 107.048L240.857 133.81L267.619 133.81L267.619 107.048L240.857 107.048Z",
    fill: "#EA6C58"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M240.857 160.571L240.857 187.333L267.619 187.333L267.619 160.571L240.857 160.571Z",
    fill: "#EA6C58"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M240.857 187.333L240.857 214.095L267.619 214.095L267.619 187.333L240.857 187.333Z",
    fill: "#EA6C58"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M240.857 214.095L240.857 240.857L267.619 240.857L267.619 214.095L240.857 214.095Z",
    fill: "#EA6C58"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M240.857 240.857L240.857 267.619L267.619 267.619L267.619 240.857L240.857 240.857Z",
    fill: "#EA6C58"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M240.857 267.619L240.857 294.381L267.619 294.381L267.619 267.619L240.857 267.619Z",
    fill: "#EA6C58"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M240.857 294.381L240.857 321.143L267.619 321.143L267.619 294.381L240.857 294.381Z",
    fill: "#FEF9EA"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M240.857 321.143L240.857 347.905L267.619 347.905L267.619 321.143L240.857 321.143Z",
    fill: "#EA6C58"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M240.857 347.905L240.857 374.667L267.619 374.667L267.619 347.905L240.857 347.905Z",
    fill: "#EA6C58"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M294.381 26.762L294.381 53.5239L321.143 53.5239L321.143 26.762L294.381 26.762Z",
    fill: "#EA6C58"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M294.381 80.2858L294.381 107.048L321.143 107.048L321.143 80.2858L294.381 80.2858Z",
    fill: "#EA6C58"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M294.381 107.048L294.381 133.81L321.143 133.81L321.143 107.048L294.381 107.048Z",
    fill: "#EA6C58"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M294.381 133.81L294.381 160.571L321.143 160.571L321.143 133.81L294.381 133.81Z",
    fill: "#EA6C58"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M294.381 160.571L294.381 187.333L321.143 187.333L321.143 160.571L294.381 160.571Z",
    fill: "#EA6C58"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M294.381 214.095L294.381 240.857L321.143 240.857L321.143 214.095L294.381 214.095Z",
    fill: "#EA6C58"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M294.381 240.857L294.381 267.619L321.143 267.619L321.143 240.857L294.381 240.857Z",
    fill: "#EA6C58"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M294.381 267.619L294.381 294.381L321.143 294.381L321.143 267.619L294.381 267.619Z",
    fill: "#EA6C58"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M294.381 294.381L294.381 321.143L321.143 321.143L321.143 294.381L294.381 294.381Z",
    fill: "#EA6C58"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M294.381 347.905L294.381 374.667L321.143 374.667L321.143 347.905L294.381 347.905Z",
    fill: "#EA6C58"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M294.381 401.429L294.381 428.19L321.143 428.19L321.143 401.429L294.381 401.429Z",
    fill: "#EA6C58"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M294.381 454.952L294.381 481.714L321.143 481.714L321.143 454.952L294.381 454.952Z",
    fill: "#EA6C58"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M294.381 481.714L294.381 508.476L321.143 508.476L321.143 481.714L294.381 481.714Z",
    fill: "#EA6C58"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M294.381 508.476L294.381 535.238L321.143 535.238L321.143 508.476L294.381 508.476Z",
    fill: "#EA6C58"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M240.857 508.476L240.857 535.238L267.619 535.238L267.619 508.476L240.857 508.476Z",
    fill: "#EA6C58"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M401.429 80.2858L401.429 107.048L428.19 107.048L428.19 80.2858L401.429 80.2858Z",
    fill: "#EA6C58"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M401.429 107.048L401.429 133.81L428.19 133.81L428.19 107.048L401.429 107.048Z",
    fill: "#EA6C58"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M401.429 133.81L401.429 160.571L428.19 160.571L428.19 133.81L401.429 133.81Z",
    fill: "#EA6C58"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M401.429 160.571L401.429 187.333L428.19 187.333L428.19 160.571L401.429 160.571Z",
    fill: "#EA6C58"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M401.429 187.333L401.429 214.095L428.19 214.095L428.19 187.333L401.429 187.333Z",
    fill: "#EA6C58"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M401.429 214.095L401.429 240.857L428.19 240.857L428.19 214.095L401.429 214.095Z",
    fill: "#EA6C58"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M401.429 240.857L401.429 267.619L428.19 267.619L428.19 240.857L401.429 240.857Z",
    fill: "#EA6C58"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M401.429 267.619L401.429 294.381L428.19 294.381L428.19 267.619L401.429 267.619Z",
    fill: "#EA6C58"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M401.429 294.381L401.429 321.143L428.19 321.143L428.19 294.381L401.429 294.381Z",
    fill: "#EA6C58"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M401.429 321.143L401.429 347.905L428.19 347.905L428.19 321.143L401.429 321.143Z",
    fill: "#EA6C58"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M401.429 347.905L401.429 374.667L428.19 374.667L428.19 347.905L401.429 347.905Z",
    fill: "#EA6C58"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M401.429 374.667L401.429 401.429L428.19 401.429L428.19 374.667L401.429 374.667Z",
    fill: "#EA6C58"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M401.429 401.429L401.429 428.19L428.19 428.19L428.19 401.429L401.429 401.429Z",
    fill: "#EA6C58"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M347.905 53.5239L347.905 80.2858L374.667 80.2858L374.667 53.5239L347.905 53.5239Z",
    fill: "#EA6C58"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M347.905 80.2858L347.905 107.048L374.667 107.048L374.667 80.2858L347.905 80.2858Z",
    fill: "#EA6C58"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M347.905 133.81L347.905 160.571L374.667 160.571L374.667 133.81L347.905 133.81Z",
    fill: "#EA6C58"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M347.905 160.571L347.905 187.333L374.667 187.333L374.667 160.571L347.905 160.571Z",
    fill: "#EA6C58"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M347.905 187.333L347.905 214.095L374.667 214.095L374.667 187.333L347.905 187.333Z",
    fill: "#EA6C58"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M347.905 214.095L347.905 240.857L374.667 240.857L374.667 214.095L347.905 214.095Z",
    fill: "#EA6C58"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M347.905 240.857L347.905 267.619L374.667 267.619L374.667 240.857L347.905 240.857Z",
    fill: "#EA6C58"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M347.905 267.619L347.905 294.381L374.667 294.381L374.667 267.619L347.905 267.619Z",
    fill: "#EA6C58"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M347.905 294.381L347.905 321.143L374.667 321.143L374.667 294.381L347.905 294.381Z",
    fill: "#EA6C58"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M347.905 321.143L347.905 347.905L374.667 347.905L374.667 321.143L347.905 321.143Z",
    fill: "#EA6C58"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M347.905 347.905L347.905 374.667L374.667 374.667L374.667 347.905L347.905 347.905Z",
    fill: "#EA6C58"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M347.905 374.667L347.905 401.429L374.667 401.429L374.667 374.667L347.905 374.667Z",
    fill: "#EA6C58"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M347.905 401.429L347.905 428.19L374.667 428.19L374.667 401.429L347.905 401.429Z",
    fill: "#EA6C58"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M347.905 428.191L347.905 454.952L374.667 454.952L374.667 428.191L347.905 428.191Z",
    fill: "#EA6C58"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M347.905 454.952L347.905 481.714L374.667 481.714L374.667 454.952L347.905 454.952Z",
    fill: "#EA6C58"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M454.952 80.2858L454.952 107.048L481.714 107.048L481.714 80.2858L454.952 80.2858Z",
    fill: "#EA6C58"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M454.952 107.048L454.952 133.81L481.714 133.81L481.714 107.048L454.952 107.048Z",
    fill: "#EA6C58"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M454.952 133.81L454.952 160.571L481.714 160.571L481.714 133.81L454.952 133.81Z",
    fill: "#EA6C58"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M454.952 160.571L454.952 187.333L481.714 187.333L481.714 160.571L454.952 160.571Z",
    fill: "#EA6C58"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M454.952 187.333L454.952 214.095L481.714 214.095L481.714 187.333L454.952 187.333Z",
    fill: "#EA6C58"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M454.952 214.095L454.952 240.857L481.714 240.857L481.714 214.095L454.952 214.095Z",
    fill: "#EA6C58"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M454.952 240.857L454.952 267.619L481.714 267.619L481.714 240.857L454.952 240.857Z",
    fill: "#EA6C58"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M454.952 267.619L454.952 294.381L481.714 294.381L481.714 267.619L454.952 267.619Z",
    fill: "#EA6C58"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M454.952 294.381L454.952 321.143L481.714 321.143L481.714 294.381L454.952 294.381Z",
    fill: "#EA6C58"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M454.952 347.905L454.952 374.667L481.714 374.667L481.714 347.905L454.952 347.905Z",
    fill: "#EA6C58"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M508.476 133.81L508.476 160.571L535.238 160.571L535.238 133.81L508.476 133.81Z",
    fill: "#EA6C58"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M508.476 187.333L508.476 214.095L535.238 214.095L535.238 187.333L508.476 187.333Z",
    fill: "#EA6C58"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M508.476 214.095L508.476 240.857L535.238 240.857L535.238 214.095L508.476 214.095Z",
    fill: "#EA6C58"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M508.476 240.857L508.476 267.619L535.238 267.619L535.238 240.857L508.476 240.857Z",
    fill: "#EA6C58"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M107.048 26.762L107.048 53.5239L133.81 53.5239L133.81 26.762L107.048 26.762Z",
    fill: "#EA6C58"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M107.048 53.5239L107.048 80.2858L133.81 80.2858L133.81 53.5239L107.048 53.5239Z",
    fill: "#EA6C58"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M107.048 80.2858L107.048 107.048L133.81 107.048L133.81 80.2858L107.048 80.2858Z",
    fill: "#EA6C58"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M107.048 107.048L107.048 133.81L133.81 133.81L133.81 107.048L107.048 107.048Z",
    fill: "#EA6C58"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M107.048 160.571L107.048 187.333L133.81 187.333L133.81 160.571L107.048 160.571Z",
    fill: "#EA6C58"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M107.048 187.333L107.048 214.095L133.81 214.095L133.81 187.333L107.048 187.333Z",
    fill: "#EA6C58"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5238 80.2858L53.5238 107.048L80.2857 107.048L80.2857 80.2858L53.5238 80.2858Z",
    fill: "#EA6C58"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5238 107.048L53.5238 133.81L80.2857 133.81L80.2857 107.048L53.5238 107.048Z",
    fill: "#EA6C58"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5238 133.81L53.5238 160.571L80.2857 160.571L80.2857 133.81L53.5238 133.81Z",
    fill: "#EA6C58"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5238 187.333L53.5238 214.095L80.2857 214.095L80.2857 187.333L53.5238 187.333Z",
    fill: "#EA6C58"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3396e-06 133.81L0 160.571L26.7619 160.571L26.7619 133.81L2.3396e-06 133.81Z",
    fill: "#EA6C58"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3396e-06 160.571L0 187.333L26.7619 187.333L26.7619 160.571L2.3396e-06 160.571Z",
    fill: "#EA6C58"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M187.333 26.762L187.333 53.5239L214.095 53.5239L214.095 26.762L187.333 26.762Z",
    fill: "#EA6C58"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M187.333 53.5239L187.333 80.2858L214.095 80.2858L214.095 53.5239L187.333 53.5239Z",
    fill: "#EA6C58"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M187.333 80.2858L187.333 107.048L214.095 107.048L214.095 80.2858L187.333 80.2858Z",
    fill: "#EA6C58"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M187.333 107.048L187.333 133.81L214.095 133.81L214.095 107.048L187.333 107.048Z",
    fill: "#EA6C58"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M187.333 133.81L187.333 160.571L214.095 160.571L214.095 133.81L187.333 133.81Z",
    fill: "#EA6C58"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M214.095 53.5239L214.095 80.2858L240.857 80.2858L240.857 53.5239L214.095 53.5239Z",
    fill: "#16332F"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M160.571 80.2858L160.571 107.048L187.333 107.048L187.333 80.2858L160.571 80.2858Z",
    fill: "#16332F"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M107.048 133.81L107.048 160.571L133.81 160.571L133.81 133.81L107.048 133.81Z",
    fill: "#16332F"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5238 160.571L53.5238 187.333L80.2857 187.333L80.2857 160.571L53.5238 160.571Z",
    fill: "#91C883"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M187.333 160.571L187.333 187.333L214.095 187.333L214.095 160.571L187.333 160.571Z",
    fill: "#16332F"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M187.333 187.333L187.333 214.095L214.095 214.095L214.095 187.333L187.333 187.333Z",
    fill: "#EA6C58"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M187.333 214.095L187.333 240.857L214.095 240.857L214.095 214.095L187.333 214.095Z",
    fill: "#EA6C58"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M187.333 240.857L187.333 267.619L214.095 267.619L214.095 240.857L187.333 240.857Z",
    fill: "#EA6C58"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M187.333 267.619L187.333 294.381L214.095 294.381L214.095 267.619L187.333 267.619Z",
    fill: "#EA6C58"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M321.143 -1.90735e-06L321.143 26.7619L347.905 26.7619L347.905 4.32251e-07L321.143 -1.90735e-06Z",
    fill: "#EA6C58"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M321.143 26.762L321.143 53.5239L347.905 53.5239L347.905 26.762L321.143 26.762Z",
    fill: "#EA6C58"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M321.143 53.5239L321.143 80.2858L347.905 80.2858L347.905 53.5239L321.143 53.5239Z",
    fill: "#EA6C58"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M321.143 80.2858L321.143 107.048L347.905 107.048L347.905 80.2858L321.143 80.2858Z",
    fill: "#EA6C58"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M321.143 107.048L321.143 133.81L347.905 133.81L347.905 107.048L321.143 107.048Z",
    fill: "#EA6C58"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M321.143 160.571L321.143 187.333L347.905 187.333L347.905 160.571L321.143 160.571Z",
    fill: "#EA6C58"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M321.143 187.333L321.143 214.095L347.905 214.095L347.905 187.333L321.143 187.333Z",
    fill: "#EA6C58"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M321.143 214.095L321.143 240.857L347.905 240.857L347.905 214.095L321.143 214.095Z",
    fill: "#EA6C58"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M321.143 240.857L321.143 267.619L347.905 267.619L347.905 240.857L321.143 240.857Z",
    fill: "#EA6C58"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M321.143 294.381L321.143 321.143L347.905 321.143L347.905 294.381L321.143 294.381Z",
    fill: "#EA6C58"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M321.143 321.143L321.143 347.905L347.905 347.905L347.905 321.143L321.143 321.143Z",
    fill: "#EA6C58"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M321.143 374.667L321.143 401.429L347.905 401.429L347.905 374.667L321.143 374.667Z",
    fill: "#EA6C58"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M321.143 401.429L321.143 428.19L347.905 428.19L347.905 401.429L321.143 401.429Z",
    fill: "#EA6C58"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M321.143 428.191L321.143 454.952L347.905 454.952L347.905 428.191L321.143 428.191Z",
    fill: "#EA6C58"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M240.857 374.667L240.857 401.429L267.619 401.429L267.619 374.667L240.857 374.667Z",
    fill: "#16332F"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M294.381 321.143L294.381 347.905L321.143 347.905L321.143 321.143L294.381 321.143Z",
    fill: "#16332F"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M294.381 374.667L294.381 401.429L321.143 401.429L321.143 374.667L294.381 374.667Z",
    fill: "#16332F"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M294.381 428.191L294.381 454.952L321.143 454.952L321.143 428.191L294.381 428.191Z",
    fill: "#91C883"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M321.143 454.952L321.143 481.714L347.905 481.714L347.905 454.952L321.143 454.952Z",
    fill: "#16332F"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M321.143 481.714L321.143 508.476L347.905 508.476L347.905 481.714L321.143 481.714Z",
    fill: "#EA6C58"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M321.143 508.476L321.143 535.238L347.905 535.238L347.905 508.476L321.143 508.476Z",
    fill: "#EA6C58"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M267.619 508.476L267.619 535.238L294.381 535.238L294.381 508.476L267.619 508.476Z",
    fill: "#EA6C58"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M267.619 535.238L267.619 562L294.381 562L294.381 535.238L267.619 535.238Z",
    fill: "#EA6C58"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M428.19 107.048L428.19 133.81L454.952 133.81L454.952 107.048L428.19 107.048Z",
    fill: "#EA6C58"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M428.19 160.571L428.19 187.333L454.952 187.333L454.952 160.571L428.19 160.571Z",
    fill: "#EA6C58"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M428.19 187.333L428.19 214.095L454.952 214.095L454.952 187.333L428.19 187.333Z",
    fill: "#EA6C58"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M428.19 214.095L428.19 240.857L454.952 240.857L454.952 214.095L428.19 214.095Z",
    fill: "#EA6C58"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M428.19 267.619L428.19 294.381L454.952 294.381L454.952 267.619L428.19 267.619Z",
    fill: "#EA6C58"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M428.19 321.143L428.19 347.905L454.952 347.905L454.952 321.143L428.19 321.143Z",
    fill: "#EA6C58"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M428.19 347.905L428.19 374.667L454.952 374.667L454.952 347.905L428.19 347.905Z",
    fill: "#EA6C58"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M428.19 374.667L428.19 401.429L454.952 401.429L454.952 374.667L428.19 374.667Z",
    fill: "#EA6C58"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M347.905 107.048L347.905 133.81L374.667 133.81L374.667 107.048L347.905 107.048Z",
    fill: "#16332F"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M321.143 133.81L321.143 160.571L347.905 160.571L347.905 133.81L321.143 133.81Z",
    fill: "#16332F"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M428.19 80.2858L428.19 107.048L454.952 107.048L454.952 80.2858L428.19 80.2858Z",
    fill: "#16332F"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M374.667 53.5239L374.667 80.2858L401.429 80.2858L401.429 53.5239L374.667 53.5239Z",
    fill: "#16332F"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M374.667 80.2858L374.667 107.048L401.429 107.048L401.429 80.2858L374.667 80.2858Z",
    fill: "#EA6C58"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M374.667 107.048L374.667 133.81L401.429 133.81L401.429 107.048L374.667 107.048Z",
    fill: "#91C883"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M374.667 133.81L374.667 160.571L401.429 160.571L401.429 133.81L374.667 133.81Z",
    fill: "#EA6C58"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M267.619 214.095L267.619 240.857L294.381 240.857L294.381 214.095L267.619 214.095Z",
    fill: "#16332F"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M240.857 133.81L240.857 160.571L267.619 160.571L267.619 133.81L240.857 133.81Z",
    fill: "#16332F"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M294.381 53.5239L294.381 80.2858L321.143 80.2858L321.143 53.5239L294.381 53.5239Z",
    fill: "#16332F"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M294.381 187.333L294.381 214.095L321.143 214.095L321.143 187.333L294.381 187.333Z",
    fill: "#91C883"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M374.667 160.571L374.667 187.333L401.429 187.333L401.429 160.571L374.667 160.571Z",
    fill: "#16332F"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M374.667 187.333L374.667 214.095L401.429 214.095L401.429 187.333L374.667 187.333Z",
    fill: "#EA6C58"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M374.667 214.095L374.667 240.857L401.429 240.857L401.429 214.095L374.667 214.095Z",
    fill: "#EA6C58"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M374.667 240.857L374.667 267.619L401.429 267.619L401.429 240.857L374.667 240.857Z",
    fill: "#EA6C58"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M374.667 294.381L374.667 321.143L401.429 321.143L401.429 294.381L374.667 294.381Z",
    fill: "#EA6C58"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M321.143 267.619L321.143 294.381L347.905 294.381L347.905 267.619L321.143 267.619Z",
    fill: "#16332F"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M321.143 347.905L321.143 374.667L347.905 374.667L347.905 347.905L321.143 347.905Z",
    fill: "#16332F"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M428.19 294.381L428.19 321.143L454.952 321.143L454.952 294.381L428.19 294.381Z",
    fill: "#16332F"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M374.667 267.619L374.667 294.381L401.429 294.381L401.429 267.619L374.667 267.619Z",
    fill: "#16332F"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M374.667 321.143L374.667 347.905L401.429 347.905L401.429 321.143L374.667 321.143Z",
    fill: "#91C883"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M374.667 347.905L374.667 374.667L401.429 374.667L401.429 347.905L374.667 347.905Z",
    fill: "#EA6C58"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M374.667 374.667L374.667 401.429L401.429 401.429L401.429 374.667L374.667 374.667Z",
    fill: "#EA6C58"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M374.667 401.429L374.667 428.19L401.429 428.19L401.429 401.429L374.667 401.429Z",
    fill: "#EA6C58"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M481.714 80.2858L481.714 107.048L508.476 107.048L508.476 80.2858L481.714 80.2858Z",
    fill: "#EA6C58"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M481.714 107.048L481.714 133.81L508.476 133.81L508.476 107.048L481.714 107.048Z",
    fill: "#EA6C58"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M481.714 133.81L481.714 160.571L508.476 160.571L508.476 133.81L481.714 133.81Z",
    fill: "#EA6C58"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M481.714 160.571L481.714 187.333L508.476 187.333L508.476 160.571L481.714 160.571Z",
    fill: "#EA6C58"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M481.714 187.333L481.714 214.095L508.476 214.095L508.476 187.333L481.714 187.333Z",
    fill: "#EA6C58"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M454.952 321.143L454.952 347.905L481.714 347.905L481.714 321.143L454.952 321.143Z",
    fill: "#91C883"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M508.476 160.571L508.476 187.333L535.238 187.333L535.238 160.571L508.476 160.571Z",
    fill: "#16332F"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M428.19 133.81L428.19 160.571L454.952 160.571L454.952 133.81L428.19 133.81Z",
    fill: "#16332F"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M428.19 240.857L428.19 267.619L454.952 267.619L454.952 240.857L428.19 240.857Z",
    fill: "#16332F"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M481.714 214.095L481.714 240.857L508.476 240.857L508.476 214.095L481.714 214.095Z",
    fill: "#16332F"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M481.714 240.857L481.714 267.619L508.476 267.619L508.476 240.857L481.714 240.857Z",
    fill: "#EA6C58"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M481.714 267.619L481.714 294.381L508.476 294.381L508.476 267.619L481.714 267.619Z",
    fill: "#EA6C58"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M481.714 294.381L481.714 321.143L508.476 321.143L508.476 294.381L481.714 294.381Z",
    fill: "#EA6C58"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M535.238 133.81L535.238 160.571L562 160.571L562 133.81L535.238 133.81Z",
    fill: "#EA6C58"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M535.238 160.571L535.238 187.333L562 187.333L562 160.571L535.238 160.571Z",
    fill: "#EA6C58"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapa);
export default __webpack_public_path__ + "static/media/mapa.8f783af61ca0d151f6f3b578c362d595.svg";
export { ForwardRef as ReactComponent };